<title mat-dialog-title>{{ 'map.clipViewVideo.title' | t }}</title>
<mat-dialog-content>
  <ng-container *ngIf="unavailable">
    <h3>
      {{ 'map.clipViewVideo.recordingUnavailable' | t }}
    </h3>
  </ng-container>
  <ng-container *ngIf="src && !unavailable">
    <sn-video-player
      #videoPlayer
      width="100%"
      height="500px"
      [src]="src"
      [local]="false"
      [autoplay]="false"
      [main]="true"
      [timestamp]="false"
      (init)="onPlayerInit($event)"
    >
      <sn-player-footer-row>
        <sn-player-progress-bar-control></sn-player-progress-bar-control>
      </sn-player-footer-row>
      <sn-player-footer-row>
        <sn-player-footer-section>
          <sn-player-play-control></sn-player-play-control>
          <sn-player-time-control></sn-player-time-control>
        </sn-player-footer-section>
        <sn-player-footer-section alignment="end">
          <sn-player-fullscreen-control></sn-player-fullscreen-control>
        </sn-player-footer-section>
      </sn-player-footer-row>
    </sn-video-player>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!unavailable">
  <sn-button color="success" type="button" (click)="clip()" [disabled]="!canClip">
    <sn-icon>content_cut</sn-icon> {{ 'map.clipViewVideo.screenshotVideo' | t }}
  </sn-button>
  <fs-download-video
    [ngClass]="{ resizeDownload: clipLoading }"
    [data]="data"
    [camera]="data.camera"
    [start]="downloadStartDate"
    [end]="downloadEndDate"
    (loadingInProgress)="getProgress($event)"
  >
  </fs-download-video>
  <sn-button color="success" type="button" (click)="addToVault()" [isLoading]="isLoading">
    <sn-icon>queue_play_next</sn-icon> {{ 'common.addToVault' | t }}
  </sn-button>
  <sn-button (click)="cancel()">{{ 'common.done' | t }}</sn-button>
</mat-dialog-actions>
